module.exports = "<div class=\"news\">\r\n  <app-header class=\"head\"></app-header>\r\n  <div class=\"news-body\">\r\n    <h1 class=\"title\">{{data['articleTitle']}}</h1>\r\n    <div class=\"content\" [innerHTML]=\"data['articleContent']\"></div>\r\n  </div>\r\n\r\n  <nz-back-top></nz-back-top>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/news-detail/news-detail.component.html
// module id = ../../../../../src/app/news-detail/news-detail.component.html
// module chunks = main